export interface OrderData {
  orderData: any;
}

export interface RotationOrderData {
  rotationOrderData: any;
}

export const initialOrderState: OrderData = {
  orderData: {
    orderList: [],
  },
};

export const initialRotationOrderState: RotationOrderData = {
  rotationOrderData: {
    orderList: [],
  },
};
